module.exports = __webpack_public_path__ + "static/banner_blog-9f3a317801d2ff9cc76f5993065facc7.png";